

const API_MAIN_URL = "http://localhost:8080/api"

async function FetchAccount(){
    return new Promise((resolve , reject) =>{
        fetch(`${API_MAIN_URL}/account` , {
            credentials:"include",
        }).then(resp => resp.json()).then((Account) =>{
            // 
            resolve(Account)
        })
    })

}

export default FetchAccount